// extracted by mini-css-extract-plugin
export default {"btn":"ButtonRound_btn__ulOdh","btnSelected":"ButtonRound_btnSelected__Vo3Rv"};